import { dataTransferWrap } from '../dataTransferService'

import WebWorkerService from '@/services/webWorkerService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

const dtMapsConfig = dtConfig[ModulesMap.MAPS]

const unzippingDataWorker = new WebWorkerService('unzippingDataWorker')
window.unzippingDataWorker = unzippingDataWorker

function getMapsTelematicChartData(companyId, machineId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TELEMATIC_CHART_DATA],
		{
			urlParams: {
				companyId,
				machineId,
			},
			params: query,
		},
	)
}

function getMapsCrops(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getMapsCropsExtendedInfo(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_CROPS_EXTENDED_INFO],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getMapsEvents(companyId, query) {
	return new Promise((resolve, reject) => {
		dataTransferWrap(
			ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_EVENTS],
			{
				urlParams: {
					companyId,
				},
				params: query,
			},
		)
			.then((res) => {
				const events = []
				for (let index = 0; index < res.length; index++) {
					const element = res[index]
					const event = {
						id: element.id,
						machineId: element.machine_id,
						type: element.event_type,
						timeInterval: element.time_interval,
						values: element.values,
						geometry: {
							type: 'Point',
							coordinates: element.values.position,
						},
					}
					// console.log('event', event)
					events.push(event)
				}
				resolve(events)
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function getMapsMovementPoints(companyId, query, dateFrom, dateTo, companyTz) {
	return new Promise((resolve, reject) => {
		dataTransferWrap(
			ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_MOVEMENT_POINTS],
			{
				urlParams: {
					companyId,
				},
				params: query,
			},
		)
			.then((res) => {
				// console.log('getMapsMovementPoints', res)
				unzippingDataWorker.runJob({
					cmd: 'movementsDecoder',
					payload: { res, dateFrom, dateTo, companyTz },
				})
					.then((result) => {
						// console.log('movement points', result)
						resolve(result)
					})
					.catch((e) => {
						// console.log('Error in worker', e)
						reject(e)
					})

				// const decoder = new MovementsDecoder(res, dateFrom, dateTo, companyTz)
				// try {
				// 	decoder.init()
				// 	// console.log('decoder', decoder)
				// } catch (error) {
				// 	reject(error)
				// }
				// // console.log('decoder', decoder)
				// resolve({
				// 	dateIndexes: decoder.date_indexes,
				// 	firstPointsMachinesWithoutMoves: decoder.first_points_machines_without_moves,
				// 	parsedData: decoder.parsed_data,
				// })
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function getMapsTracks(companyId, query, dateFrom, dateTo, companyTz) {
	return new Promise((resolve, reject) => {
		dataTransferWrap(
			ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS],
			{
				urlParams: {
					companyId,
				},
				params: query,
			},
		)
			.then((res) => {
				// console.log('getMapsTracks DT', res)

				unzippingDataWorker.runJob({
					cmd: 'unzipSourcesLines',
					payload: { source: res, dateFrom, dateTo, companyTz },
				})
					.then((result) => {
						// console.log('linesSource', result)
						resolve(result)
					})
					.catch((e) => {
						// console.log('Error in worker', e)
						reject(e)
					})
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function getMapsTracksExtendedInfo(companyId, query) {
	return new Promise((resolve, reject) => {
		dataTransferWrap(
			ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_EXTENDED_INFO],
			{
				urlParams: {
					companyId,
				},
				params: query,
			},
		)
			.then((res) => {
				const extendedInfo = Object.fromEntries(res.map((item) => [item.machine_id, item]))
				resolve(extendedInfo)
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function getMapsTracksMovedMachines(companyId, query) {
	return new Promise((resolve, reject) => {
		dataTransferWrap(
			ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_MOVED_MACHINES],
			{
				urlParams: {
					companyId,
				},
				params: query,
			},
		)
			.then((res) => {
				const extendedInfo = Object.fromEntries(res.map((item) => [item.machine_id, item]))
				resolve(extendedInfo)
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function getMapsTracksRealtimeData(companyId) {
	return new Promise((resolve, reject) => {
		dataTransferWrap(
			ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_TRACKS_REALTIME_DATA],
			{
				urlParams: {
					companyId,
				},
			},
		)
			.then((res) => {
				const tracksRealtime = Object.fromEntries(res.map((item) => [item.machine_id, item]))
				resolve(tracksRealtime)
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function getMapsFieldWorks(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_FIELD_WORKS],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getMapsLogisticWorks(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_LOGISTIC_WORKS],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getMapsPreview(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MAPS_PREVIEW],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getMachineTrack(companyId, machineId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK],
		{
			urlParams: {
				companyId,
				machineId,
			},
			params: query,
		},
	)
}

function getRelatedFieldWorks(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_RELATED_FIELD_WORKS],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getMachineWideTrack(companyId, machineId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK],
		{
			urlParams: {
				companyId,
				machineId,
			},
			params: query,
		},
	)
}
function getMachineWideTrackCrossedCrops(companyId, machineId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_WIDE_TRACK_CROSSED_CROPS],
		{
			urlParams: {
				companyId,
				machineId,
			},
			params: query,
		},
	)
}

function getMachineTrackPoints(companyId, machineId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_MACHINE_TRACK_POINTS],
		{
			urlParams: {
				companyId,
				machineId,
			},
			params: query,
		},
	)
}

function getSatelliteImageDates(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATES],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getSatelliteImageDateDynamic(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE_DATE_DYNAMIC],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getSatelliteImages(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getSatelliteImage(companyId, satelliteImageId) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGE],
		{
			urlParams: {
				companyId,
				satelliteImageId,
			},
		},
	)
}

function getSatelliteImagesStats(companyId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_SATELLITE_IMAGES_STATS],
		{
			urlParams: {
				companyId,
			},
			params: query,
		},
	)
}

function getDoneWorkGeometries(companyId, doneWorkId, query) {
	return dataTransferWrap(
		ModulesMap.MAPS, dtMapsConfig[ModulesConfigMap[ModulesMap.MAPS].GET_DONE_WORK_GEOMETRIES],
		{
			urlParams: {
				companyId,
				doneWorkId,
			},
			params: query,
		},
	)
}

export default {
	getMapsTelematicChartData,
	getMapsCrops,
	getMapsCropsExtendedInfo,
	getMapsEvents,
	getMapsMovementPoints,
	getMapsTracks,
	getMapsTracksExtendedInfo,
	getMapsTracksMovedMachines,
	getMapsTracksRealtimeData,
	getMapsFieldWorks,
	getMapsLogisticWorks,
	getMapsPreview,
	getMachineTrack,
	getRelatedFieldWorks,
	getMachineWideTrack,
	getMachineWideTrackCrossedCrops,
	getMachineTrackPoints,
	getSatelliteImageDates,
	getSatelliteImageDateDynamic,
	getSatelliteImages,
	getSatelliteImage,
	getSatelliteImagesStats,
	getDoneWorkGeometries,
}
